import React from "react";
import { Check, X } from "lucide-react";
import { Link } from "react-router-dom";

const TILTS = ["-rotate-1", "rotate-0", "rotate-1", "-rotate-2", "rotate-2"];

export default function ComparisonCard({ comparison, index = 0 }) {
  const tilt = TILTS[index % TILTS.length];
  const darkHeader = !!comparison.darkHeader;
  const headingClr = darkHeader ? "text-cream" : "text-jet";
  const supertitleClr = darkHeader ? "text-cream/80" : "text-jet/70";

  return (
    <article
      data-testid={`comparison-card-${comparison.slug}`}
      className={`relative overflow-hidden rounded-[2rem] border-2 border-jet bg-cream shadow-pop-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-pop-xl ${tilt} hover:rotate-0`}
    >
      <div
        className="border-b-2 border-jet p-6"
        style={{ background: comparison.accent }}
      >
        <p className={`font-sans text-[11px] font-extrabold uppercase tracking-[0.22em] ${supertitleClr}`}>
          Supergrain Showdown
        </p>
        <h3 className={`mt-2 font-sans text-3xl font-extrabold leading-[1.04] tracking-tight md:text-4xl ${headingClr}`}>
          Milet{" "}
          <span
            className="mx-1 inline-block rotate-[-3deg] rounded-full border-2 border-jet bg-butter px-2.5 py-0.5 align-middle font-sans text-xl font-black uppercase tracking-[0.05em] text-jet md:text-2xl"
            style={{ boxShadow: "2px 2px 0 #0B0B0F" }}
          >
            vs
          </span>{" "}
          <span className="block md:inline">{comparison.competitor}</span>
        </h3>
      </div>

      <div className="grid grid-cols-2">
        <div className="border-r-2 border-jet p-5">
          <p className="font-sans text-[11px] font-extrabold uppercase tracking-[0.2em] text-earth-hard">
            MILET
          </p>
          <ul className="mt-3 space-y-2">
            {comparison.milletWins.map((w, i) => (
              <li key={i} className="flex items-start gap-2 font-sans text-sm font-medium">
                <Check size={16} className="mt-1 shrink-0 text-earth-medium" strokeWidth={3} />
                <span>{w}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="p-5">
          <p className="font-sans text-[11px] font-extrabold uppercase tracking-[0.2em] text-pink">
            {comparison.competitor.toUpperCase()}
          </p>
          <ul className="mt-3 space-y-2">
            {comparison.competitorIssues.map((w, i) => (
              <li key={i} className="flex items-start gap-2 font-sans text-sm font-medium">
                <X size={16} className="mt-1 shrink-0 text-pink" strokeWidth={3} />
                <span>{w}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t-2 border-jet p-5">
        <p className="font-sans text-base font-semibold leading-snug text-jet">
          &ldquo;{comparison.verdict}&rdquo;
        </p>
        <Link
          to={`/blog/${comparison.blogSlug}`}
          data-testid={`comparison-card-link-${comparison.slug}`}
          className="mt-3 inline-block border-b-2 border-jet font-sans text-xs font-extrabold uppercase tracking-[0.22em] hover:text-cobalt"
        >
          Read the full breakdown →
        </Link>
      </div>
    </article>
  );
}
